import { UiColors } from 'assets/styles/old/global';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  margin-top: 8px;
`;

export const BarContainer = styled.div`
  position: relative;
  flex: 1;
  height: 20px;
  background-color: var(--soft-dark);
  border-radius: 8px;
  overflow: hidden;
`;

export const Filler = styled.div`
  height: 100%;
  width: ${(props) => props.progress}%;
  background-color: ${UiColors.orangeColor};
  transition: width 0.3s ease-in-out;
`;

export const PercentText = styled.span`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: var(--white);
  font-size: 12px;
  font-weight: bold;
`;

export const CancelButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  flex-shrink: 0;
`;

export const ErrorText = styled.span`
  color: ${UiColors.redColor || 'red'};
  font-size: 12px;
  margin-top: 4px;
`;
